import React from 'react'
import { ClipboardCopy } from '@components/ClipboardCopy/ClipboardCopy'
import { Icon, IconButton, Paragraph, Pill, Stack } from '@ui'
import { useBalance } from 'hooks/useBalance'
import { shortAddress } from 'ui/utils/utils'
import { Address } from 'use-towns-client'

export function WalletWithBalance({
    address,
    isAbstractAccount,
    onRemoveClick,
    onCopyClick,
    showBalance = false,
    isPrimaryWallet = false,
    CardPopup,
}: {
    address: Address
    isAbstractAccount: boolean
    showBalance?: boolean
    onCopyClick?: () => void
    onRemoveClick?: (address: Address) => void
    isPrimaryWallet?: boolean
    CardPopup?: React.ReactNode
}) {
    const balance = useBalance({
        address: address,
        enabled: showBalance,
    })

    const WalletCopy = () => {
        return (
            <Stack horizontal gap="sm">
                <ClipboardCopy
                    color={isAbstractAccount ? 'gray2' : 'gray1'}
                    label={shortAddress(address)}
                    clipboardContent={address}
                    onClick={onCopyClick}
                />
                {isPrimaryWallet && (
                    <Pill background="level3" fontSize="xs" height="x2">
                        Primary
                    </Pill>
                )}
            </Stack>
        )
    }

    return (
        <Stack horizontal gap="sm" justifyContent="spaceBetween" alignItems="center" width="100%">
            {isAbstractAccount && (
                <Stack gap="sm">
                    <Paragraph>Towns Base Wallet</Paragraph>
                    <WalletCopy />
                </Stack>
            )}
            {!isAbstractAccount && (
                <Stack horizontal centerContent gap="sm">
                    <WalletCopy />
                </Stack>
            )}
            <Stack horizontal centerContent gap="sm">
                {showBalance && (
                    <>
                        {balance.data?.formatted ?? 0} {balance.data?.symbol ?? ''}
                        <Icon type="base" color="coinbaseBlue" size="square_sm" />
                    </>
                )}
                {onRemoveClick && (
                    <IconButton
                        data-testid="wallet-with-balance-remove-wallet"
                        icon="close"
                        tooltip="Remove Wallet"
                        onClick={() => onRemoveClick?.(address)}
                    />
                )}
                {CardPopup}
            </Stack>
        </Stack>
    )
}
